import React, { ReactNode, useMemo } from 'react';

import { PhoneInput, PhoneItem, ReadonlyItem, Space } from '@/components';
import { PhoneType, Value } from '@/model/common';

interface SubjectItemProps {
  'data-test'?: string;
  value?: Value<{
    phone: PhoneType;
    name?: string;
  }>;
  shortPhoneMask?: boolean;
  readonly?: boolean;
  onChange?: (value: string) => Promise<void> | void;
  messages: {
    label: ReactNode;
    phoneLabel: ReactNode;
    phoneError: ReactNode;
  };
}

const SubjectItem: React.FC<SubjectItemProps> = ({
  value,
  shortPhoneMask,
  onChange,
  readonly,
  messages,
  'data-test': dataTest,
}) => {
  const name = value?.value?.name;
  const phoneValue = value?.value?.phone;
  const phone = useMemo(
    () =>
      phoneValue && (
        <span style={{ paddingTop: 4 }}>
          <PhoneInput value={phoneValue} readonly shortMask />
        </span>
      ),
    [phoneValue],
  );
  return readonly ? (
    <ReadonlyItem label={messages.label} textClassName="ym-hide-content" data-test={dataTest}>
      <Space direction="vertical" size={0}>
        {name && <span data-test={dataTest && `${dataTest}-name`}>{name}</span>}
        {phone && <span data-test={dataTest && `${dataTest}-phone`}>{phone}</span>}
      </Space>
    </ReadonlyItem>
  ) : (
    <PhoneItem
      data-test={dataTest}
      value={{
        value: value?.value?.phone,
        hasError: !!value?.hasError,
      }}
      shortMask={shortPhoneMask}
      /* eslint-disable-next-line @typescript-eslint/no-empty-function */
      onChange={onChange || ((): void => {})}
      messages={{
        label: messages.phoneLabel,
        error: messages.phoneError,
      }}
    />
  );
};

export default SubjectItem;
